export const ADMIN = {
  // Login
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  loginError: "admin-login-error",

  // Dashboard
  dashboard: "admin-dashboard",
  navCallbacks: "admin-nav-callbacks",
  navTestimonials: "admin-nav-testimonials",
  navServices: "admin-nav-services",
  logoutBtn: "admin-logout-btn",

  // Lists
  callbackRow: (id) => `admin-callback-row-${id}`,
  callbackStatusSelect: (id) => `admin-callback-status-${id}`,
  callbackDeleteBtn: (id) => `admin-callback-delete-${id}`,

  testimonialRow: (id) => `admin-testimonial-row-${id}`,
  testimonialEditBtn: (id) => `admin-testimonial-edit-${id}`,
  testimonialDeleteBtn: (id) => `admin-testimonial-delete-${id}`,
  testimonialAddBtn: "admin-testimonial-add",
  testimonialFormName: "admin-testimonial-form-name",
  testimonialFormQuote: "admin-testimonial-form-quote",
  testimonialFormLocation: "admin-testimonial-form-location",
  testimonialFormAge: "admin-testimonial-form-age",
  testimonialFormImage: "admin-testimonial-form-image",
  testimonialFormActive: "admin-testimonial-form-active",
  testimonialFormSubmit: "admin-testimonial-form-submit",

  serviceRow: (id) => `admin-service-row-${id}`,
  serviceEditBtn: (id) => `admin-service-edit-${id}`,
  serviceDeleteBtn: (id) => `admin-service-delete-${id}`,
  serviceAddBtn: "admin-service-add",
  serviceFormTitle: "admin-service-form-title",
  serviceFormTagline: "admin-service-form-tagline",
  serviceFormDescription: "admin-service-form-description",
  serviceFormIcon: "admin-service-form-icon",
  serviceFormOrder: "admin-service-form-order",
  serviceFormActive: "admin-service-form-active",
  serviceFormSubmit: "admin-service-form-submit",
};
